import { Typography, Button, Modal, CheckCircleBrokenIcon } from '@ag1/ui';
import classes from './ModalConfirmationScreenContent.module.scss';
import { ModalConfirmationScreenProps } from './types';

const ModalConfirmationScreenContent = ({
  title,
  subtitle,
  description,
  ctaLabel = 'Ok',
  ctaOnClick
}: Omit<ModalConfirmationScreenProps, 'isOpen' | 'onClose'>) => (
  <>
    <Modal.Header>{title}</Modal.Header>
    <Modal.Content hasFooter={false}>
      <div className={classes.content}>
        <CheckCircleBrokenIcon className={classes.icon} />
        <div className={classes.description}>
          <Typography color="black-new" variant="portalSubtitle" size="2" weight="700" noPadding>
            {subtitle}
          </Typography>
          <Typography color="black-new" variant="portalText" size="1" noPadding>
            {description}
          </Typography>
        </div>
        {ctaOnClick && (
          <Button
            variant="primary"
            size={{ xxs: 'medium', s: 'large' }}
            theme="new"
            onClick={ctaOnClick}>
            {ctaLabel}
          </Button>
        )}
      </div>
    </Modal.Content>
  </>
);

export default ModalConfirmationScreenContent;
